import Requester from "./Requester";

interface CreateDTO {
    email?: string
    name: string
    phone?: string
    description?: string
}

export function getClients() {
    const requester = new Requester();

    return requester.get(requester.getUrl('api/clients'))
}

export function destroy(id) {
    const requester = new Requester();

    return requester.delete(requester.getUrl(`api/clients/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/clients`), values)
}

export default {
    create,
    getClients,
    destroy,
}